import { AxiosInstance, AxiosRequestConfig } from "axios";

import {
  FirstTimeCallTimeResponseI,
  GoalTrackerResponseI,
  LifetimePerformanceResponseI,
  PerformanceCampaignStatsResponseI,
  PerformanceDashboardResponseI,
  PerformanceRevenueResponseI,
  TodayPerformanceResponseI,
  UpdateGoalTrackerRequestI,
  DailyDealsMeetingsResponseI,
  PerformanceLeaderboardResponseI,
} from "@/api/routes/performance/interfaces";
import { PerformanceChartDataResponseI } from "shared/lib/interfaces/performance";

export const PerformanceAPIEndpoints = (API: AxiosInstance) => ({
  fetchPerformanceDashboard: (
    campaignId: string,
    startDate: string,
    endDate: string | undefined
  ) =>
    API.get<PerformanceDashboardResponseI>("/v1/performance/main", {
      params: {
        campaign_id: campaignId,
        start_date: startDate,
        end_date: endDate,
      },
    }),

  fetchPerformanceRevenue: (campaignIds: string[], startDate: string) =>
    API.post<PerformanceRevenueResponseI>("/v1/performance/revenue", {
      campaign_ids: campaignIds,
      start_date: startDate,
    }),

  fetchPerformanceCampaignStats: (campaignId: string) =>
    API.get<PerformanceCampaignStatsResponseI>(
      "/v1/performance/campaign_stats",
      {
        params: { campaign_id: campaignId },
      }
    ),

  fetchLifetimePerformance: () =>
    API.get<LifetimePerformanceResponseI>(
      "/v1/performance/lifetime_performance"
    ),

  fetchTodayPerformance: () =>
    API.get<TodayPerformanceResponseI>("/v2/performance/today_performance"),

  fetchGoalTrackerMetrics: () =>
    API.get<GoalTrackerResponseI>("/v1/performance/goal/current"),

  updateGoalTrackerMetrics: (metrics: UpdateGoalTrackerRequestI) =>
    API.post("/v1/performance/goal/update", metrics),

  fetchFirstCallTime: () =>
    API.get<FirstTimeCallTimeResponseI>("/v1/performance/first_call_time"),

  // Both dashboard reads accept a per-call config so the leaderboard module
  // can set its own (longer) timeout instead of the client-wide default.
  fetchDailyDealsMeetings: (config?: AxiosRequestConfig) =>
    API.get<DailyDealsMeetingsResponseI>(
      "/v1/performance/daily_deals_meetings",
      config
    ),

  fetchPerformanceLeaderboard: (month?: string, config?: AxiosRequestConfig) =>
    API.get<PerformanceLeaderboardResponseI>("/v1/performance/leaderboard", {
      ...config,
      params: month ? { month } : undefined,
    }),

  fetchPerformanceChartData: (campaignIds: string[]) =>
    API.post<PerformanceChartDataResponseI>("/v1/performance_chart", {
      campaign_ids: campaignIds,
    }),
});
